function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaconAndEggs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297 297",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#503B2C"
    },
    cx: 148.5,
    cy: 148.5,
    r: 148.5
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#423024"
    },
    d: "M296.903,143.392l-66.535-66.534C174.2,122.148,107.636,156.205,72.5,225.5 c-3.356,6.041-11.184,10.773-19.329,14.401l50.085,50.071C117.522,294.53,132.722,297,148.5,297c82.014,0,148.5-66.486,148.5-148.5 C297,146.789,296.96,145.088,296.903,143.392z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D95459"
    },
    d: "M80.472,242.149c4.069,0,7.424-3.14,7.755-7.196c0.974-11.944,4.273-14.303,4.273-30.267 c0-18.731-4.541-18.731-4.541-37.462c0-18.729,4.541-18.729,4.541-37.457c0-18.729-4.541-18.729-4.541-37.458 c0-15.314,3.036-18.106,4.143-28.853c0.473-4.596-3.115-8.604-7.735-8.604H62.528c-4.069,0-7.424,3.14-7.755,7.196 C53.798,73.991,50.5,76.35,50.5,92.314c0,18.731,4.541,18.731,4.541,37.462c0,18.729-4.541,18.729-4.541,37.457 c0,18.729,4.541,18.729,4.541,37.458c0,15.314-3.036,18.106-4.143,28.853c-0.473,4.596,3.115,8.604,7.735,8.604L80.472,242.149 L80.472,242.149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D95459"
    },
    d: "M134.472,242.149c4.069,0,7.424-3.14,7.755-7.196c0.974-11.944,4.273-14.303,4.273-30.267 c0-18.731-4.541-18.731-4.541-37.462c0-18.729,4.541-18.729,4.541-37.457c0-18.729-4.541-18.729-4.541-37.458 c0-15.314,3.036-18.106,4.143-28.853c0.473-4.596-3.115-8.604-7.735-8.604h-21.839c-4.069,0-7.424,3.14-7.755,7.196 c-0.974,11.944-4.273,14.303-4.273,30.267c0,18.731,4.541,18.731,4.541,37.462c0,18.729-4.541,18.729-4.541,37.457 c0,18.729,4.541,18.729,4.541,37.458c0,15.314-3.036,18.106-4.143,28.853c-0.473,4.596,3.115,8.604,7.735,8.604L134.472,242.149 L134.472,242.149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.54,76.648c22.131-15.3,65.212-40.977,107.619,0c32.25,31.162-10.824,61.294-17.937,107.619 c-7.066,46.019-47.288,89.501-107.619,35.873S61.137,119.099,122.54,76.648z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3E5E4"
    },
    d: "M230.159,76.648c-29.197-28.213-58.713-24.829-81.492-14.99v182.511 c35.504,6.015,58.39-26.261,63.555-59.902C219.335,137.942,262.409,107.81,230.159,76.648z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4AF30"
    },
    cx: 122.54,
    cy: 166.33,
    r: 33.699
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA800"
    },
    d: "M148.667,145.052v42.557c4.731-5.802,7.572-13.208,7.572-21.279S153.398,150.854,148.667,145.052z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaconAndEggs);
export default __webpack_public_path__ + "static/media/bacon_and_eggs.2b296adafa2e690b86645d0b742f89b7.svg";
export { ForwardRef as ReactComponent };